import React from 'react';
import { motion } from 'framer-motion';
import { Shield, BookOpen, Store, Users } from 'lucide-react';
const features = [{
  icon: Shield,
  title: 'The Sanctum',
  description: 'A fortified community space where gothic creators share work, discuss craft, and find their tribe without judgment.'
}, {
  icon: BookOpen,
  title: 'Obsidian Archive',
  description: 'A curated library of dark fantasy literature, horror scripts, gothic art collections, and atmospheric soundscapes.'
}, {
  icon: Store,
  title: 'The Thornmarket',
  description: 'A dedicated marketplace for dark art prints, horror manuscripts, gothic jewelry, ambient music, and bespoke commissions.'
}, {
  icon: Users,
  title: 'Vesper Circle',
  description: 'Intimate collaboration rooms where writers meet illustrators, composers find filmmakers, and dark visions become shared reality.'
}];
export function FeaturesSection() {
  return <section id="features" className="py-24 bg-charcoal relative overflow-hidden" data-id="element-10">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/black-linen.png')] opacity-20" data-id="element-11" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-12">
        <div className="text-center mb-20" data-id="element-13">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} data-id="element-14">
            <h2 className="font-heading text-4xl md:text-5xl text-parchment mb-4" data-id="element-15">
              The Offerings
            </h2>
            <p className="font-body text-xl text-bone/60 max-w-2xl mx-auto" data-id="element-16">
              Tools and spaces forged for the nocturnal creative.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16" data-id="element-17">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: index * 0.1
        }} className="flex gap-6 items-start group" data-id="element-18">
              <div className="flex-shrink-0 mt-1" data-id="element-19">
                <div className="w-14 h-14 bg-obsidian border border-white/10 flex items-center justify-center rotate-45 group-hover:border-amber-glow/50 group-hover:bg-amber-glow/5 transition-all duration-500" data-id="element-20">
                  <feature.icon className="-rotate-45 w-6 h-6 text-bone group-hover:text-amber-glow transition-colors duration-300" data-id="element-21" />
                </div>
              </div>
              <div data-id="element-22">
                <h3 className="font-heading text-2xl font-bold text-parchment mb-3 group-hover:text-amber-glow transition-colors duration-300" data-id="element-23">
                  {feature.title}
                </h3>
                <p className="font-body text-lg text-bone/70 leading-relaxed" data-id="element-24">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}